import { Mail, Phone, MapPin } from "lucide-react";
import { exportBrochurePdf } from "../utils/exportPdf";

export default function CTAFooter() {
  return (
    <>
      {/* Final CTA */}
      <section
        id="cta"
        data-testid="cta-section"
        className="relative py-32 lg:py-44 bg-white overflow-hidden border-t border-[#C8D3DF]"
      >
        <div className="absolute inset-0 tech-grid opacity-15 pointer-events-none" />

        {/* Background floating product */}
        <div className="absolute right-0 bottom-0 w-[600px] opacity-15 pointer-events-none -mr-32 -mb-32">
          <img
            src="/assets/ewp1110_render7.png"
            alt=""
            aria-hidden="true"
            className="w-full"
          />
        </div>

        <div className="max-w-5xl mx-auto px-6 lg:px-12 relative text-center">
          <div className="reveal">
            <span className="spec-label justify-center inline-flex">Become an MPS MWP1110 Distributor</span>
          </div>
          <h2
            data-testid="final-cta-headline"
            className="font-chivo font-black text-5xl sm:text-6xl lg:text-8xl tracking-tighter text-[#1A2232] leading-[0.92] mt-6 reveal"
          >
            Upgrade your VAG<br />
            <span className="text-[#5B9BD5]">aftermarket catalog.</span>
          </h2>
          <p className="mt-7 font-plex text-base lg:text-lg text-[#536073] max-w-2xl mx-auto leading-relaxed reveal">
            Stock the MPS MWP1110 — the only switchable coolant pump for VAG that fails open. Talk to our team about distribution terms, MOQs and territory exclusivity.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4 reveal">
            <a
              href="mailto:sales@multiparts.net?subject=MWP1110%20Distribution%20Inquiry"
              data-testid="cta-email"
              className="btn-tech"
            >
              sales@multiparts.net <span aria-hidden>→</span>
            </a>
            <a
              href="tel:+15617481515"
              data-testid="cta-phone"
              className="btn-ghost"
            >
              +1 561 748 1515
            </a>
          </div>

          {/* Export full brochure to PDF */}
          <div className="mt-6 flex flex-col items-center gap-2 reveal">
            <button
              type="button"
              onClick={exportBrochurePdf}
              data-testid="cta-download-brochure"
              className="btn-tech"
            >
              Download PDF Brochure <span aria-hidden>↓</span>
            </button>
            <span className="font-mono text-[10px] tracking-[0.2em] text-[#8896A6] uppercase">
              Full product brochure · A4 · Print or Save as PDF
            </span>
          </div>

          {/* Contact cards */}
          <div className="mt-14 grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto reveal">
            <ContactCard icon={Mail} label="Email" value="sales@multiparts.net" />
            <ContactCard icon={Phone} label="Phone" value="+1 561 748 1515" />
            <ContactCard icon={MapPin} label="HQ" value="Jupiter, FL · USA" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        data-testid="site-footer"
        className="relative bg-white border-t border-[#C8D3DF] py-10"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <a
            href="#top"
            aria-label="MPS Multi Parts — home"
            className="flex items-center gap-3 group"
          >
            <div className="bg-white rounded-md px-2.5 py-1.5 flex items-center justify-center shadow-[0_0_18px_rgba(91,155,213,0.15)] group-hover:shadow-[0_0_22px_rgba(91,155,213,0.35)] transition-shadow">
              <img
                src="/assets/mps-logo.png"
                alt="MPS Multi Parts logo"
                className="h-9 w-auto object-contain"
              />
            </div>
            <span className="font-mono text-[10px] text-[#8896A6] tracking-[0.18em] uppercase">
              Engineered Precision · Jupiter, FL · USA
            </span>
          </a>

          <div className="font-mono text-[10px] tracking-[0.2em] text-[#8896A6] uppercase text-center">
            © {new Date().getFullYear()} MPS Multi Parts · multiparts.net · All rights reserved
          </div>

          <div className="flex items-center gap-3">
            <a
              href="mailto:sales@multiparts.net"
              data-testid="footer-email"
              className="font-mono text-[10px] tracking-[0.2em] text-[#536073] hover:text-[#5B9BD5] uppercase"
            >
              sales@multiparts.net
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

function ContactCard({ icon: Icon, label, value }) {
  return (
    <div className="border border-[#C8D3DF] rounded-sm p-5 bg-white/60 backdrop-blur-md hover:border-[#5B9BD5]/50 transition-colors">
      <div className="flex items-center justify-center mb-3">
        <Icon size={16} className="text-[#5B9BD5]" />
      </div>
      <div className="font-mono text-[10px] tracking-[0.25em] text-[#8896A6] uppercase mb-1">
        {label}
      </div>
      <div className="font-chivo font-bold text-[#1A2232] text-sm">{value}</div>
    </div>
  );
}
